import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import noDataImg from '~/assets/no-data.svg';
import { gray } from '~/components/mixins/color';

const Container = styled.div `
  display: ${props => props.visible ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100% - 60px);

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${props => props.size};
    height: ${props => props.size};
    max-height: 150px;
    opacity: 0.4;
    user-select: none;
    pointer-events: none;
  }

  img {
    height: 70%;
    border: none;
    opacity: 1;
  }

  h5 {
    color: ${props => props.color || gray.fade(0.6).string()} !important;
    font-size: 16px !important;
    padding: 10px !important;
  }
`;

function EmptyState(props) {
  const { size = '60%', color, text, visible } = props;

  if (!visible) {
    return null;
  }
  return (
    <Container visible={visible} size={size} color={color}>
      <div className="circle">
        <img src={noDataImg} alt="logo" title={size}/>
      </div>
      <h5> {text} </h5>
    </Container>
  );
}

EmptyState.propTypes = {
  text: PropTypes.string.isRequired,
  visible: PropTypes.bool
}

EmptyState.defaultProps = {
  text: '',
  visible: false
}

export default EmptyState;
